function fullName(account) {
  return account.first_name + " " + account.last_name;
}

function shorterFullName(account) {
  const name = fullName(account).split(" ");

  return name[0] + " " + name[name.length - 1];
}

function firstName(account) {
  return account.first_name.split(" ")[0];
}

function profilePicture(account) {
  const { profile } = account;

  return profile && profile.profile_picture
    ? profile.profile_picture
    : "/static/donie.svg";
}

export default {
  fullName,
  shorterFullName,
  firstName,
  profilePicture
};



// WEBPACK FOOTER //
// ./src/utils/helpers/account.js